__turbopack_context__.v({
  "className": "geistmono_8e2790ea-module__fuNg9a__className",
  "variable": "geistmono_8e2790ea-module__fuNg9a__variable",
});
